import React, { useState, useRef, useEffect } from "react";
import "./UploadReel.css";
import "../../Components/Header/Header.css";
import Header from "./../../Components/Header/Header";
import ConfirmIconLogo from "../../assets/images/ConfirmIconLogo.png";
import SuccessIcon from "../../assets/images/SuccessIcon.png";
import ArrowRight from "../../assets/images/arrow-right-circle.svg";
import { useNavigate } from "react-router-dom";
import ReelSelectionModel from "../ReelReferenceEditor/ReelSelectionModel.jsx";
import DeleteIcon from "../../assets/images/Delete-icon.svg";
import { callApi } from "../../utils/apiService.js";
import { videoCreatorEndPoint } from "../../Constants/constants.js";
import { useUser } from "../../Context/UserContext.jsx";
import Select from "react-select";
import { showToast } from "../../utils/toastUtils.js";

export default function UploadReel() {
  const [isUploading, setIsUploading] = useState(false);
  const [reelFile, setReelFile] = useState(null);
  const [reelCaption, setReelCaption] = useState("");
  const [reelType, setReelType] = useState("");
  const [reelLanguage, setReelLanguage] = useState("");
  const [contentCategory, setContentCategory] = useState("");
  const [showCategoryHelp, setShowCategoryHelp] = useState(false);
  const [reelPreview, setReelPreview] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadComplete, setUploadComplete] = useState(true);
  const [showRemoveButton, setShowRemoveButton] = useState(false);
  const [thumbnailUploadProgress, setThumbnailUploadProgress] = useState(0);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [errors, setErrors] = useState({});
  const [confirmChecked, setConfirmChecked] = useState(false);
  const [reelTypes, setReelTypes] = useState([]);
  const [reeList, setReelist] = useState([]);

  const [reelDuration, setReelDuration] = useState(0);
  const [reelName, setReelName] = useState("");
  const [reelFileType, setReelFileType] = useState("");
  const [reelSize, setReelSize] = useState("");
  const [thumbnailName, setThumbnailName] = useState("");
  const [thumbnailFileType, setThumbnailFileType] = useState("");
  const [thumbnailSize, setThumbnailSize] = useState("");
  const navigate = useNavigate();
  const reelInputRef = useRef(null);
  const thumbnailInputRef = useRef(null);
  const { languages, user } = useUser();

  const handleReelDrop = (e) => {
    const file = e.target.files[0];

    if (file && file.type.startsWith("video/")) {
      setReelFile(file);
      setReelPreview(URL.createObjectURL(file));

      setReelName(file.name.split(".").slice(0, -1).join("."));
      setReelFileType(file.type);
      setReelSize(file.size);

      const video = document.createElement("video");
      video.preload = "metadata";

      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        setReelDuration(Math.round(video.duration));
      };

      video.src = URL.createObjectURL(file);

      setErrors((prev) => ({
        ...prev,
        reelFile: "",
      }));

      simulateUploadProgress();
    }
  };
  const handleReelChange = (e) => {
    const file = e.target.files[0];

    if (file && file.type.startsWith("video/")) {
      setReelFile(file);
      setReelPreview(URL.createObjectURL(file));

      setReelName(file.name.split(".").slice(0, -1).join("."));
      setReelFileType(file.type);
      setReelSize(file.size);

      const video = document.createElement("video");
      video.preload = "metadata";

      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        setReelDuration(Math.round(video.duration));
      };

      video.src = URL.createObjectURL(file);

      setErrors((prev) => ({
        ...prev,
        reelFile: "",
      }));

      simulateUploadProgress();
    }
  };

  const simulateUploadProgress = () => {
    setUploadComplete(false);
    setShowRemoveButton(false);
    setUploadProgress(0);

    const interval = setInterval(() => {
      setUploadProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setUploadComplete(true);
          setShowRemoveButton(true);
          return 100;
        }
        const next = prev + Math.random() * 30;
        return next >= 100 ? 100 : next;
      });
    }, 1000);
  };
  const fetchReelTypes = async () => {
    try {
      const response = await callApi(
        `${videoCreatorEndPoint}reel/types/list`,
        "GET",
      );
      if (response?.status) {
        setReelTypes(response?.data || []);
      }
    } catch (err) {}
  };

  useEffect(() => {
    fetchReelTypes();
  }, []);

  useEffect(() => {
    if (!showCategoryHelp) return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") setShowCategoryHelp(false);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showCategoryHelp]);

  const validateForm = () => {
    const newErrors = {};

    if (!reelFile) {
      newErrors.reelFile = "Please upload a reel file";
    }

    if (!reelCaption.trim()) {
      newErrors.reelCaption = "Reel caption is required";
    }

    if (!reelType) {
      newErrors.reelType = "Please select a reel type";
    }

    if (!reelLanguage) {
      newErrors.reelLanguage = "Please select a reel language";
    }

    if (!contentCategory) {
      newErrors.contentCategory = "Please select a content category";
    }

    if (!thumbnail) {
      newErrors.thumbnail = "Please upload a thumbnail";
    }

    if (!confirmChecked) {
      newErrors.confirm = "Please confirm you have rights to use this content";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const simulateThumbnailUploadProgress = () => {
    setThumbnailUploadProgress(0);
    const interval = setInterval(() => {
      setThumbnailUploadProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + Math.random() * 30;
      });
    }, 500);
  };

  const handleThumbnailDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith("image/")) {
      setThumbnail(file);
      setThumbnailPreview(URL.createObjectURL(file));
      setErrors((prev) => ({
        ...prev,
        thumbnail: "",
      }));
      setThumbnailName(file.name.split(".").slice(0, -1).join("."));
      setThumbnailFileType(file.type);
      setThumbnailSize(file.size);
      simulateThumbnailUploadProgress();
    }
  };

  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setThumbnail(file);
      setThumbnailPreview(URL.createObjectURL(file));
      setErrors((prev) => ({
        ...prev,
        thumbnail: "",
      }));
      setThumbnailName(file.name.split(".").slice(0, -1).join("."));
      setThumbnailFileType(file.type);
      setThumbnailSize(file.size);
      simulateThumbnailUploadProgress();
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handlePublish = () => {
    if (!validateForm()) return;

    setShowConfirmModal(true);
  };

  const handleConfirmSubmit = async () => {
    setIsUploading(true);
    try {
      const payload = {
        reelTypeId: reelType,
        title: reelName,
        caption: reelCaption,
        reelLanguageId: reelLanguage,
        reelDuration,
        reelFileType,
        reelSize,
        reelName,
        thumbnailName,
        thumbnailFileType,
        thumbnailSize,
        ...(selectedVideo?.id && { relatedVideo: selectedVideo.id }),
        contentCategory,
      };

      const response = await callApi(
        `${videoCreatorEndPoint}reel/create`,
        "POST",
        payload,
      );

      if (response?.status) {
        const { reelUploadUrl, thumbnailUploadUrl } = response.data;

        await fetch(reelUploadUrl, {
          method: "PUT",
          body: reelFile,
        });

        await fetch(thumbnailUploadUrl, {
          method: "PUT",
          body: thumbnail,
        });

        setShowConfirmModal(false);
        setShowSuccessModal(true);

        setTimeout(() => {
          setReelFile(null);
          setReelPreview(null);
          setThumbnail(null);
          setThumbnailPreview(null);
          setReelCaption("");
          setReelType("");
          setReelLanguage("");
          setContentCategory("");
          setUploadProgress(0);
          setThumbnailUploadProgress(0);
          setConfirmChecked(false);
        }, 2000);
      } else {
        setShowConfirmModal(false);
        showToast(
          "error",
          response?.message || response?.alert || "Failed to create reel. Please try again.",
        );
      }
    } catch (error) {
      setShowConfirmModal(false);
      showToast(
        "error",
        error?.response?.data?.message ||
          error?.message ||
          "Failed to create reel. Please try again.",
      );
    } finally {
      setIsUploading(false);
    }
  };

  const handleCancel = () => {
    if (
      window.confirm(
        "Are you sure you want to cancel? All changes will be lost.",
      )
    ) {
      setReelFile(null);
      setReelPreview(null);
      setThumbnail(null);
      setThumbnailPreview(null);
      setReelCaption("");
      setReelType("");
      setReelLanguage("");
      setContentCategory("");
      setUploadProgress(0);
      setThumbnailUploadProgress(0);
      setConfirmChecked(false);
    }
  };

  const handleDone = () => {
    setShowSuccessModal(false);
    window.location.href = "/dashboard";
  };

  const handleViewApprovedList = () => {
    setShowSuccessModal(false);
    window.location.href = "/view-awaiting-list";
  };

  const handleRemoveReel = () => {
    setReelFile(null);
    setReelPreview(null);
    setUploadProgress(0);
    setUploadComplete(false);
    setShowRemoveButton(false);
  };

  const reelTypeOptions = reelTypes.map((item) => ({
    value: item.id,
    label: item.dataName,
  }));

  const languageOptions = languages.map((item) => ({
    value: item.id,
    label: item.dataName,
  }));

  const contentCategoryOptions = [
    { value: "MOTION", label: "Motion" },
    { value: "STATIC", label: "Static" },
  ];

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "48px",
      borderRadius: "8px",
      borderColor: state.isFocused ? "#a855f7" : "#dbcfe8",
      backgroundColor: "#faf7fc",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(168, 85, 247, 0.1)" : "none",
      "&:hover": {
        borderColor: "#a855f7",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 12px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#6b7280",
      fontSize: "14px",
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "14px",
      color: "#1f2937",
    }),
  };

  return (
    <div>
      {isUploading && (
        <div className="upload-loader-overlay">
          <div className="upload-loader" />
        </div>
      )}
      <Header />
      <div className="upload-reel-container">
        <div className="upload-reel-content">
          <h1 className="reel-page-title">Upload Reel</h1>

          {/* Tabs */}
          <div className="reel-tabs-container">
            <div className="reel-tab reel-tab-active">Reel</div>
          </div>

          <form className="reel-form">
            <div className="reel-form-grid">
              {/* Left Column */}
              <div className="reel-form-left">
                {/* Reel File Section */}
                <div className="reel-form-section">
                  <label className="reel-file-label">Reel File</label>
                  <p className="reel-file-description">
                    Upload your reel file ( MP4, MOV, AVI, WEBM,M4V,MKV
                    supported)
                  </p>

                  {!reelPreview ? (
                    <div
                      className={`reel-upload-area ${
                        errors.reelFile ? "reel-field-error" : ""
                      }`}
                      onDrop={handleReelDrop}
                      onDragOver={handleDragOver}
                    >
                      <p className="reel-upload-main-text">
                        Drag and drop to upload
                      </p>
                      <p className="reel-upload-hint">
                        Drag and drop your video file here, or click to browse
                      </p>
                      <button
                        type="button"
                        className="reel-browse-button"
                        onClick={() => reelInputRef.current?.click()}
                      >
                        Browse
                      </button>
                      <input
                        ref={reelInputRef}
                        type="file"
                        accept="video/*"
                        onChange={handleReelChange}
                        style={{ display: "none" }}
                      />
                    </div>
                  ) : (
                    <div className="reel-preview-container">
                      <video
                        className="reel-video-preview"
                        src={reelPreview}
                        controls
                      />
                    </div>
                  )}
                  {errors.reelFile && (
                    <span className="error-text">{errors.reelFile}</span>
                  )}
                </div>
                {!uploadComplete && (
                  <div className="reel-progress-container">
                    <div className="reel-progress-bar">
                      <div
                        className="reel-progress-fill"
                        style={{ width: `${uploadProgress}%` }}
                      />
                    </div>
                    <div className="reel-progress-percentage">
                      {Math.round(uploadProgress)}%
                    </div>
                  </div>
                )}
                {showRemoveButton && (
                  <button
                    type="button"
                    className="reel-remove-button"
                    onClick={handleRemoveReel}
                  >
                    Remove
                  </button>
                )}
              </div>

              {/* Right Column */}
              <div className="reel-form-right">
                <div className="reel-form-section">
                  <label className="reel-form-label">Reel Caption</label>
                  <textarea
                    className={`reel-caption-textarea ${
                      errors.reelCaption ? "reel-field-error" : ""
                    }`}
                    placeholder="Tell viewers about your reel"
                    value={reelCaption}
                    onChange={(e) => {
                      setReelCaption(e.target.value);

                      if (errors.reelCaption) {
                        setErrors((prev) => ({
                          ...prev,
                          reelCaption: "",
                        }));
                      }
                    }}
                  />
                  {errors.reelCaption && (
                    <span className="error-text">{errors.reelCaption}</span>
                  )}
                </div>
              </div>
            </div>

            {/* Thumbnail Section */}
            <div className="reel-form-section">
              <label className="reel-form-label">Thumbnail</label>

              {!thumbnailPreview ? (
                <div
                  className={`reel-upload-area ${
                    errors.thumbnail ? "reel-field-error" : ""
                  }`}
                  onDrop={handleThumbnailDrop}
                  onDragOver={handleDragOver}
                >
                  <p className="reel-upload-main-text">
                    Drag and drop to upload
                  </p>
                  <p className="reel-upload-hint">
                    Drag and drop your Thumbnail file here, or click to browse
                  </p>
                  <button
                    type="button"
                    className="reel-browse-button"
                    onClick={() => thumbnailInputRef.current?.click()}
                  >
                    Browse
                  </button>
                  <input
                    ref={thumbnailInputRef}
                    type="file"
                    accept="image/*"
                    onChange={handleThumbnailChange}
                    style={{ display: "none" }}
                  />
                </div>
              ) : (
                <div className="reel-thumbnail-preview-section">
                  {thumbnailPreview && (
                    <>
                      <div className="reel-thumbnail-container">
                        <img
                          src={thumbnailPreview}
                          alt="Thumbnail preview"
                          className="reel-thumbnail-preview"
                        />
                      </div>

                      <div className="reel-upload-progress-container">
                        <div className="reel-progress-bar">
                          <div
                            className="reel-progress-fill"
                            style={{ width: `${thumbnailUploadProgress}%` }}
                          />
                        </div>
                        {thumbnailUploadProgress < 100 ? (
                          <div className="reel-progress-percentage">
                            {Math.round(thumbnailUploadProgress)}%
                          </div>
                        ) : (
                          <div className="reel-thumbnail-uploaded-label">
                            Thumbnail uploaded successfully
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
              {errors.thumbnail && (
                <span className="error-text">{errors.thumbnail}</span>
              )}
            </div>

            <div className="reel-form-section reel-video-link-section">
              <div className="youtube-link-header">
                <label className="reel-form-label">
                  + Video Link (Add a video link for reference)
                </label>
                <img src={ArrowRight} alt="Arrow Right" />
              </div>
              <div>
                {selectedVideo ? (
                  <div className="selected-video-info">
                    <img
                      src={selectedVideo.generatedThumbnail}
                      alt={selectedVideo.title}
                      className="selected-video-thumbnail"
                    />
                    <h4>{selectedVideo.title}</h4>
                    <button
                      type="button"
                      className="reel-delete-button"
                      onClick={() => setSelectedVideo(null)}
                    >
                      <div className="button-alignments">
                        <img
                          src={DeleteIcon}
                          alt="delete-icon"
                          className="delete-icon"
                        />
                        Delete
                      </div>
                    </button>
                  </div>
                ) : (
                  <button
                    type="button"
                    className="add-button-inside"
                    onClick={() => setShowModal(true)}
                  >
                    Add Video Link
                  </button>
                )}
              </div>
            </div>

            {/* Reel Type */}
            <div className="reel-bottom-grid">
              <div className="reel-form-section">
                <label className="reel-form-label">Reel Type</label>
                <Select
                  options={reelTypeOptions}
                  placeholder="Select a reel type"
                  value={
                    reelTypeOptions.find(
                      (option) => option.value === reelType,
                    ) || null
                  }
                  onChange={(selected) => {
                    setReelType(selected?.value || "");

                    if (errors.reelType) {
                      setErrors((prev) => ({
                        ...prev,
                        reelType: "",
                      }));
                    }
                  }}
                  styles={{
                    ...customSelectStyles,
                    control: (provided, state) => ({
                      ...customSelectStyles.control(provided, state),
                      borderColor: errors.reelType
                        ? "#ef4444"
                        : state.isFocused
                          ? "#a855f7"
                          : "#dbcfe8",
                    }),
                  }}
                />
                {errors.reelType && (
                  <span className="error-text">{errors.reelType}</span>
                )}
              </div>

              {/* Reel Language */}
              <div className="reel-form-section">
                <label className="reel-form-label">Reel Language</label>
                <Select
                  options={languageOptions}
                  placeholder="Select a reel language"
                  value={
                    languageOptions.find(
                      (option) => option.value === reelLanguage,
                    ) || null
                  }
                  onChange={(selected) => {
                    setReelLanguage(selected?.value || "");

                    if (errors.reelLanguage) {
                      setErrors((prev) => ({
                        ...prev,
                        reelLanguage: "",
                      }));
                    }
                  }}
                  styles={{
                    ...customSelectStyles,
                    control: (provided, state) => ({
                      ...customSelectStyles.control(provided, state),
                      borderColor: errors.reelLanguage
                        ? "#ef4444"
                        : state.isFocused
                          ? "#a855f7"
                          : "#dbcfe8",
                    }),
                  }}
                />
                {errors.reelLanguage && (
                  <span className="error-text">{errors.reelLanguage}</span>
                )}
              </div>

              <div className="reel-form-section">
                <div className="category-label-row">
                  <label className="reel-form-label" htmlFor="reel-content-category">
                    Content Category
                  </label>
                  <button
                    type="button"
                    className="category-info-button"
                    aria-label="Learn about content categories"
                    onClick={() => setShowCategoryHelp(true)}
                  >
                    i
                  </button>
                </div>
                <Select
                  inputId="reel-content-category"
                  options={contentCategoryOptions}
                  placeholder="Select Motion or Static"
                  value={
                    contentCategoryOptions.find(
                      (option) => option.value === contentCategory,
                    ) || null
                  }
                  onChange={(selected) => {
                    setContentCategory(selected?.value || "");
                    if (errors.contentCategory) {
                      setErrors((prev) => ({ ...prev, contentCategory: "" }));
                    }
                  }}
                  styles={{
                    ...customSelectStyles,
                    control: (provided, state) => ({
                      ...customSelectStyles.control(provided, state),
                      borderColor: errors.contentCategory
                        ? "#ef4444"
                        : state.isFocused
                          ? "#a855f7"
                          : "#dbcfe8",
                    }),
                  }}
                />
                {errors.contentCategory && (
                  <span className="error-text">{errors.contentCategory}</span>
                )}
              </div>

              <div
                className={`story-link-header ${errors.confirm ? "story-checkbox-error" : ""}`}
              >
                <input
                  type="checkbox"
                  name="rememberMe"
                  className="checkbox-input"
                  checked={confirmChecked}
                  onChange={(e) => {
                    setConfirmChecked(e.target.checked);
                    if (errors.confirm) {
                      setErrors((prev) => ({
                        ...prev,
                        confirm: "",
                      }));
                    }
                  }}
                />
                <label
                  htmlFor="allow-comments"
                  className="story-checkbox-label"
                >
                  I confirm this content is my own or I have rights to use it.
                </label>
              </div>
              {errors.confirm && (
                <p className="story-error-message">{errors.confirm}</p>
              )}
            </div>

            {/* Form Buttons */}
            <div className="reel-form-buttons">
              <button
                type="button"
                className="reel-cancel-button"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className="reel-publish-button"
                onClick={handlePublish}
              >
                Publish
              </button>
            </div>
          </form>
        </div>

        {showCategoryHelp && (
          <div
            className="reel-modal-overlay"
            onClick={() => setShowCategoryHelp(false)}
          >
            <div
              className="reel-modal-content content-category-help-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="reel-category-help-title"
              onClick={(event) => event.stopPropagation()}
            >
              <h2 id="reel-category-help-title">Choosing a content category</h2>
              <p>
                <strong>Motion:</strong> Choose this when the video shows clear,
                meaningful movement or action, such as a car driving, someone
                walking, dancing, or exercising.
              </p>
              <p>
                <strong>Static:</strong> Choose this when the scene is mostly
                still. Small natural movements, such as head or hand gestures
                while someone speaks, are considered Static.
              </p>
              <button
                type="button"
                className="reel-modal-submit-button"
                onClick={() => setShowCategoryHelp(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}

        {/* Confirmation Modal */}
        {showConfirmModal && (
          <div className="reel-modal-overlay">
            <div className="reel-modal-content reel-confirm-modal">
              <img src={ConfirmIconLogo} alt="confirm icon" />
              <h2 className="reel-modal-title">Submit Reels for Approval?</h2>
              <p className="reel-modal-message">
                Are you sure you want to submit this reel for admin approval?
                Once approved, you won't be able to edit or make changes to this
                reel.
              </p>
              <div className="reel-modal-buttons">
                <button
                  className="reel-modal-cancel-button"
                  onClick={() => setShowConfirmModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="reel-modal-submit-button"
                  onClick={handleConfirmSubmit}
                  disabled={isUploading}
                >
                  {isUploading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Success Modal */}
        {showSuccessModal && (
          <div className="reel-modal-overlay">
            <div className="reel-modal-content reel-success-modal">
              <img src={SuccessIcon} alt="success icon" />
              <h2 className="reel-modal-title-success">
                Your Reel has Been Submitted for Approval
              </h2>
              <p className="reel-modal-message-success">
                The reel has been submitted successfully and is under admin
                review. You can check its status anytime in the Content Awaiting
                Approval list.
              </p>
              <div className="reel-modal-buttons">
                <button className="reel-modal-done-button" onClick={handleDone}>
                  Okay
                </button>
                <button
                  className="reel-modal-submit-button"
                  onClick={handleViewApprovedList}
                >
                  View Approved list
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {showModal && (
        <ReelSelectionModel
          onClose={() => setShowModal(false)}
          onSelect={(video) => {
            setSelectedVideo(video);
            setShowModal(false);
          }}
        />
      )}
    </div>
  );
}
